export const VERSION = '4.3.0-gogreen';
export const GIT_HASH = '7298badbbfa80c0f11b244f0230fb61db0c1188c';
export const BUILD_DATE = '';
export const CLIENT_BRAND = 'gg';
